import React from "react";
import { FormField } from "@modules/formx-react";
import FormAutosuggest from "../forms/common/FormAutosuggest";
import { toJS } from "mobx";

export type TextAutosuggestProps = {
  name: string;
  label?: string;
  options: LabelValue[];
  helperText?: string;
};
export function TextAutosuggest(props: TextAutosuggestProps) {
  const { name, label, helperText, options } = props;

  return (
    <FormField name={name}>
      {(field, store) => (
        <FormAutosuggest
          value={field.value}
          onChange={(x) => store.setValue(name, x)}
          label={label}
          error={!!field.error}
          options={toJS(options)}
          helperText={helperText}
        />
      )}
    </FormField>
  );
}
